import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Typography } from '@comparethemarketau/manor-typography';

const useStyles = createUseStyles((theme) => ({
    higherExcessHighlightCardContainer: {
        display: 'flex',
        padding: theme.spacing[4],
        borderRadius: theme.borderRadius.default,
        background: theme.colors.error50,
        alignItems: 'center'
    },
    text: {
        fontSize: theme.fontSize.xs,
        lineHeight: theme.lineHeight.none,
        color: theme.colors.error500,
        textAlign: 'center'
    },
    amount: {
        extend: 'text',
        fontWeight: theme.fontWeight.bold
    }
}));

const HigherExcessHighlightCard = ({ excessText }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        <div className={classes.higherExcessHighlightCardContainer}>
            <Typography component="span" className={classNames(classes.text)}>
                {'Excess is more than'}
                <Typography display="inline" className={classNames(classes.amount)}>{` ${excessText}`}</Typography>
            </Typography>
        </div>
    );
};

HigherExcessHighlightCard.propTypes = {
    excessText: PropTypes.string.isRequired
};

export { HigherExcessHighlightCard };
